<template>
    <div class="number-input" v-disabled="disabled">
        <input type="text"
               :id="id"
               class="form-control"
               v-c:form-control-sm="small"
               v-model="localValue"
               @blur="updateValue(localValue)"
        >
        <icon name="menu-left" @click="decrease"/>
        <icon name="menu-right" @click="increase"/>
    </div>
</template>

<script>
    import {getPluginConfig} from "../start-ui";
    import {formatNumber, escapeRegExp} from "../helper";

    export default {
        props: {
            value: [String, Number],
            id: {required: false, type: String},
            small: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            min: {type: Number, default: null},
            max: {type: Number, default: null},
            step: {type: Number, default: 10},
            afterComma: {type: Number, default: null},
        },

        data() {
            return {
                localValue: this.value,
                floatSeparator: getPluginConfig('ui').floatSeparator,
                thousandsSeparator: getPluginConfig('ui').thousandsSeparator,
            };
        },

        methods: {
            // remove thousands separator and change comma separator to dots
            cleanUp(value) {
                return Number(String(value).replace(new RegExp(escapeRegExp(this.thousandsSeparator), 'g'), '').replace(escapeRegExp(this.floatSeparator), '.'));
            },

            updateValue(value) {
                let number = this.cleanUp(value);
                // if invalid data is entered, replace it with last valid data and stop
                if (Number.isNaN(number)) {
                    this.localValue = this.value;
                    return;
                }

                if (this.max !== null && number > this.max) {
                    this.localValue = this.max;
                    number = this.max;
                } else if (this.min !== null && number < this.min) {
                    this.localValue = this.min;
                    number = this.min;
                }

                //let result = this.afterComma ? Number(number).toFixed(this.afterComma) : Number(number);
                this.localValue = formatNumber(number, this.afterComma);
                this.$emit('input',  number);
            },

            decrease() {
                let value = this.cleanUp(this.localValue) - this.step;
                if (this.min !== null && value <= this.min) {
                    value = this.min;
                }
                this.updateValue(value);
            },

            increase() {
                let value = this.cleanUp(this.localValue) + this.step;
                if (this.max !== null && value >= this.max) {
                    value = this.max;
                }
                this.updateValue(value);
            },
        },

        watch: {
            value() {
                this.localValue = formatNumber(this.value, this.afterComma);
            },
        },

        mounted() {
            this.localValue = formatNumber(this.localValue, this.afterComma);
        },
    };
</script>